import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomPhoneInput from '@/app/customComponents/CustomPhoneInput/CustomPhoneInput';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import * as Actions from '@/app/store/actions';
import { getImageUrl, isImageFile, isInValidName } from '@/utils/utils';
import {
	Avatar,
	Checkbox,
	CircularProgress,
	FormControl,
	FormHelperText,
	InputLabel,
	ListItemIcon,
	ListItemText,
	MenuItem,
	Select,
	TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isPossiblePhoneNumber } from 'libphonenumber-js/min';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSubAdminById, updateSubAdmin } from '../../../../services/subSchoolAdmin/SubSchoolAdmin';
import { getPermissions } from '@shared/services/users';
import '../addSchoolAdmin/addSchoolAdmin.css';
import { useNavigate } from 'react-router-dom';
import PageHeader from '@/app/customComponents/PageHeader';

const useStyles = makeStyles({
	root: {
		color: 'white',
	},
	select: {
		'&:before': {
			borderBottom: 'none',
		},
		'&:after': {
			borderBottom: 'none',
		},
		'&:not(.Mui-disabled):hover::before': {
			borderBottom: 'none',
		},
		'& .MuiSelect-select:focus': {
			backgroundColor: 'inherit',
		},
	},
	icon: {
		fill: 'white',
	},
	content: {
		position: 'relative',
		display: 'flex',
		overflow: 'auto',
		flex: '1 1 auto',
		flexDirection: 'column',
		width: '100%',
		'-webkit-overflow-scrolling': 'touch',
		zIndex: 2,
	},
});
let arr = [];
const EditSchoolAdmin = () => {
	const classes = useStyles();
	const params = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [errTxts, setErrTxts] = useState({ first_name: '', last_name: '', phone: '', permissions: [] });
	const [form, setForm] = useState({
		first_name: '',
		last_name: '',
		phone: '',
		profile_image_url: '',
	});
	const [isAdding, setIsAdding] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [roles, setRoles] = useState([]);
	const [selected, setSelected] = useState([]);
	const [preview, setPreview] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [showPermissions, setShowPermissions] = useState(false);

	const inputRef = useRef(null);

	const isAllSelected = roles.length > 0 && selected.length === roles.length;
	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
		getContentAnchorEl: null,
		anchorOrigin: {
			vertical: 'bottom',
			horizontal: 'center',
		},
		transformOrigin: {
			vertical: 'top',
			horizontal: 'center',
		},
		variant: 'menu',
	};

	useEffect(() => {
		let isMounted = true;
		getPermissions('admin', 'sub_admin')
			.then((res) => {
				if (!isMounted) return;
				// console.log(res);
				setRoles(res.data);
				arr = res.data;
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch permissions, please refresh',
						variant: 'error',
					})
				);
			});
		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		let isMounted = true;
		const id = setTimeout(() => {
			if (!isMounted) return;
			getSubAdminById(params?.id)
				.then((res) => {
					if (!isMounted) return;
					if (res.data.role === 'sub_admin') {
						setShowPermissions(true);
					}
					setSelected(
						arr?.filter((role) => {
							return res?.data?.permissions.some((permission) => permission.id === role.id);
						})
					);
					setForm({
						first_name: res?.data?.first_name,
						last_name: res?.data?.last_name,
						// email: res.data.email,
						phone: res?.data?.phone,
					});
					setPreview(res?.data?.photo);
					setEmail(res?.data?.email);
					setPhone(res?.data?.phone);
					setIsLoading(true);
				})
				.catch(() => {
					if (!isMounted) return;
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch subadmins, please refresh',
							variant: 'error',
						})
					);
					setIsLoading(true);
				});
		}, 1000);

		return () => {
			isMounted = false;
			clearTimeout(id);
		};
	}, [params?.id]);

	useEffect(() => {
		if (!selectedFile) {
			setPreview(null);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setErrTxts({ ...errTxts, [name]: '' });
		// setForm({ ...form, [name]: value });
		// console.log(value);

		if (name === 'permissions') {
			// const setPer = val?.props?.value;
			// const perfilter = selected.some(item => item.id === setPer?.id);

			// if (!perfilter) {
			// 	setSelected(prev => [...prev, setPer]);
			// } else {
			// 	setSelected(prev => prev.filter(item => item.id !== setPer.id));
			// }
			setSelected(value);
			setForm({ ...form, [name]: value });
		} else {
			setForm({ ...form, [name]: value });
		}
		if (name === 'permissions' && value[value.length - 1] === 'all') {
			setSelected(selected.length === roles.length ? [] : roles);
			setForm({ ...form, permissions: selected.length === roles.length ? [] : roles });
		}
	};
	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(null);
			return;
		}
		const file = e.target.files[0];
		if (!isImageFile(file)) {
			dispatch(Actions.showMessage({ message: 'Please select an image file', variant: 'error' }));
		} else {
			setSelectedFile(e.target.files[0]);
		}
	};
	const handleSubmit = () => {
		setErrTxts({});

		if (!form.first_name) {
			setErrTxts({ ...errTxts, first_name: 'This field is required' });
			return;
		}
		if (form.first_name && isInValidName(form.first_name)) {
			setErrTxts({ ...errTxts, first_name: 'Please enter a valid name.' });
			return;
		}
		form.first_name = form.first_name.trim();
		if (!form.last_name) {
			setErrTxts({ ...errTxts, last_name: 'This field is required' });
			return;
		}
		if (form.last_name && isInValidName(form.last_name)) {
			setErrTxts({ ...errTxts, last_name: 'Please enter a valid name.' });
			return;
		}
		form.last_name = form.last_name.trim();
		if (!form.phone) {
			setErrTxts({ ...errTxts, phone: 'This field is required' });
			return;
		}
		if (form.phone) {
			if (isPossiblePhoneNumber(form.phone, 'US') === false) {
				setErrTxts({ ...errTxts, phone: 'Please enter valid phone number' });
				return;
			}
		}
		if (form?.permissions?.length < 1) {
			setErrTxts({ ...errTxts, permissions: 'This field is required' });
			return;
		}
		form.permissions = selected?.map((roles) => roles.id);
		const data = JSON.parse(JSON.stringify(form));
		if (form.phone == phone) {
			delete data.phone;
		}
		if (selectedFile) {
			const filename = getImageUrl(selectedFile);
			setIsAdding(true);
			uploadFile(selectedFile, filename)
				.then((response) => {
					data.profile_image_url = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					updateSubAdmin(data, params?.id)
						.then(() => {
							dispatch(
								Actions.showMessage({
									message: 'Sub Admin updated successfully',
									autoHideDuration: 1500,
									variant: 'success',
								})
							);
							navigate(-1);
						})
						.catch((err) => {
							if (err.response?.data?.errors) {
								setErrTxts(err.response.data.errors);
							} else {
								dispatch(
									Actions.showMessage({
										message: 'Failed to update sub admin.',
										autoHideDuration: 1500,
										variant: 'error',
									})
								);
							}
						})
						.finally(() => setIsAdding(false));
				})
				.catch(() => {
					dispatch(
						Actions.showMessage({
							message: 'Failed to upload image',
							autoHideDuration: 1500,
							variant: 'error',
						})
					);
					setIsAdding(false);
				});
		} else {
			setIsAdding(true);
			updateSubAdmin(data, params?.id)
				.then(() => {
					dispatch(
						Actions.showMessage({
							message: 'Sub Admin updated successfully',
							autoHideDuration: 1500,
							variant: 'success',
						})
					);
					navigate(-1);
				})
				.catch((err) => {
					if (err.response?.data?.errors) {
						setErrTxts(err.response.data.errors);
					} else {
						dispatch(
							Actions.showMessage({
								message: 'Failed to update sub admin.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					}
				})
				.finally(() => setIsAdding(false));
		}
	};
	const onBack = () => {
		navigate(-1);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="add-schoolAdmin-div mx-auto">
				<div className="mb-[162px] mx-60">
					<div className="flex justify-between items-end my-[40px]">
						<PageHeader onBack={onBack} title="Edit School Admin" />
					</div>
					<div className="bg-white rounded-12 form-admin-main-div">
						{!isLoading ? (
							<div className="flex justify-center">
								<CircularProgress className="mx-auto" />
							</div>
						) : (
							<div className="form-admin-inner-div">
								<div className="shrink-0 " style={{ marginBottom: '20px' }}>
									<span className="font-bold" style={{ fontSize: '18px' }}>
										Admin Information
									</span>
								</div>
								<div className="bg-white rounded mx-auto" style={{ paddingBottom: '70px' }}>
									<div className="profile-div">
										<div
											className="profile-image-div"
											onClick={() => inputRef.current.click()}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													inputRef.current.click();
												}
											}}
											role="button"
											tabIndex={0}
										>
											<Avatar
												className="profile-image"
												src={preview}
												style={{ width: 160, height: 160, cursor: 'pointer' }}
											/>
											<div className="schooladmin-pp-overlay">
												<i className="fa fa-2x fa-camera" style={{ cursor: 'pointer' }} />
											</div>
											<input
												accept="image/*"
												className="hidden"
												name="image"
												onChange={onSelectFile}
												ref={inputRef}
												type="file"
											/>
										</div>

										<div className="grid grid-cols-2 edit-subadmin" style={{ columnGap: 100, rowGap: 40 }}>
											<TextField
												error={!!errTxts.first_name}
												label="First Name"
												name="first_name"
												onChange={handleChange}
												style={{ width: '100%' }}
												value={form?.first_name}
											/>
											<TextField
												error={!!errTxts.last_name}
												label="Last Name"
												name="last_name"
												onChange={handleChange}
												style={{ width: '100%' }}
												value={form?.last_name}
											/>
											<TextField
												InputLabelProps={{
													style: { color: 'grey' },
												}}
												disabled
												label="Email Address"
												name="email"
												onChange={handleChange}
												style={{ width: '100%' }}
												value={email}
											/>
											<CustomPhoneInput
												error={!!errTxts.phone}
												label="Contact Number"
												name="phone"
												onChange={handleChange}
												required
												style={{ width: '100%' }}
												value={form.phone}
											/>
											<FormControl
												className={`${classes.formControl} student-slt ${showPermissions ? '' : 'hidden'}`}
												error={!!errTxts.permissions?.length}
												style={{ width: '100%' }}
											>
												<InputLabel id="mutiple-select-label">Permissions</InputLabel>
												<Select
													MenuProps={MenuProps}
													error={!!errTxts.permissions?.length}
													id="permissions"
													labelId="mutiple-select-label"
													multiple
													name="permissions"
													onChange={handleChange}
													renderValue={(sel) => {
														return sel.length === roles?.length
															? 'Select All Permissions'
															: sel?.map((roles) => roles?.name?.split('_')?.join(' '))?.join(', ');
													}}
													value={selected}
												>
													<MenuItem
														classes={{
															root: isAllSelected ? classes.selectedAll : '',
														}}
														value="all"
													>
														<ListItemIcon id="all-roles">
															<Checkbox
																checked={isAllSelected}
																classes={{
																	indeterminate: classes.indeterminateColor,
																}}
																indeterminate={selected.length > 0 ? selected.length < roles.length : null}
															/>
														</ListItemIcon>
														<ListItemText classes={{ primary: classes.selectAllText }} primary="Select All" />
													</MenuItem>

													{roles.length ? (
														roles.map((role) => {
															return (
																<MenuItem key={role.id} value={role}>
																	<ListItemIcon id={`roles-${role?.id}`}>
																		<Checkbox checked={selected?.map((ro) => ro?.id).indexOf(role?.id) > -1} />
																	</ListItemIcon>
																	<ListItemText primary={role?.name.split('_').join(' ')} />
																</MenuItem>
															);
														})
													) : (
														<MenuItem disabled>Loading...</MenuItem>
													)}
												</Select>
												{errTxts.permissions ? <FormHelperText>{errTxts.permissions}</FormHelperText> : null}
											</FormControl>
										</div>
									</div>
								</div>
								<div className="flex justify-center w-max mt-40" style={{ gap: '20px' }}>
									{isAdding ? (
										<div className="flex justify-center">
											<CircularProgress className="mx-auto" />
										</div>
									) : (
										<>
											<CustomButton
												onClick={() => {
													navigate(-1);
												}}
												variant="secondary"
												width={140}
											>
												Cancel
											</CustomButton>
											<CustomButton
												onClick={() => {
													handleSubmit();
												}}
												variant="primary"
												width={140}
											>
												Update
											</CustomButton>
										</>
									)}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default EditSchoolAdmin;
